import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2a54caf6&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/bootstrap.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./assets/css/font-awesome.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./assets/css/adminlte.min.css?vue&type=style&index=2&lang=css&"
import style3 from "./assets/css/skin-purple.min.css?vue&type=style&index=3&lang=css&"
import style4 from "sweetalert2/dist/sweetalert2.min.css?vue&type=style&index=4&lang=css&"
import style5 from "./assets/scss/main.scss?vue&type=style&index=5&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports